export default "__VITE_ASSET__CDyNBe0Q__"